import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-3xl font-bold text-center" }
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-map-marked" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-phone-square-alt fa-lg" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-envelope-square fa-lg" }, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_11 = ["href"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "fab fa-linkedin fa-lg" }, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_15 = ["href"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "fab fa-github-square fa-lg" }, null, -1)
const _hoisted_17 = [
  _hoisted_16
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.name), 1),
    _createElementVNode("p", _hoisted_2, [
      _createElementVNode("span", null, [
        _hoisted_3,
        _createTextVNode(" " + _toDisplayString(_ctx.address), 1)
      ]),
      _hoisted_4,
      _createElementVNode("span", null, [
        _hoisted_5,
        _createTextVNode(" " + _toDisplayString(_ctx.phoneNumber), 1)
      ]),
      _hoisted_6,
      _createElementVNode("span", null, [
        _createElementVNode("a", { href: _ctx.mailToLink }, _hoisted_9, 8, _hoisted_7),
        _createTextVNode(" " + _toDisplayString(_ctx.emailId), 1)
      ]),
      _hoisted_10,
      _createElementVNode("span", null, [
        _createElementVNode("a", {
          href: _ctx.linkedInURL,
          target: "_blank"
        }, _hoisted_13, 8, _hoisted_11)
      ]),
      _hoisted_14,
      _createElementVNode("span", null, [
        _createElementVNode("a", { href: _ctx.githubURL }, _hoisted_17, 8, _hoisted_15)
      ])
    ])
  ]))
}